// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dark-theme-input .form-control {
  background-color: var(--bs-body-bg) !important;
  color: #e0e0e0 !important;
  border: 2px solid var(--bs-border-color) !important;
}

.dark-theme-input .form-control::placeholder {
  color: #fff !important;
}

.dark-theme-input .form-control:focus {
  border-color: #6200ea !important;
  box-shadow: 0 0 5px rgba(98, 0, 234, 0.8) !important;
}

.hold-progress-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  background-color: #ffc107; /* yellow/orange */
  width: 100%;
  animation: holdBarFill 3s linear forwards;
  border-radius: 0 0 4px 4px;
}

@keyframes holdBarFill {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}

/* Bulk selection styles */
.bulk-actions {
  margin-bottom: 1rem;
}

input[type="checkbox"] {
  cursor: pointer;
}

.bulk-edit-btn {
  transition: all 0.3s ease;
}

.bulk-edit-count {
  background-color: rgba(255, 255, 255, 0.15);
  padding: 0.2rem 0.5rem;
  border-radius: 50%;
  margin-left: 0.5rem;
  font-size: 0.8rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/CRTDatabase.css"],"names":[],"mappings":"AAAA;EACE,8CAA8C;EAC9C,yBAAyB;EACzB,mDAAmD;AACrD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,yBAAyB,EAAE,kBAAkB;EAC7C,WAAW;EACX,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,WAAW;EACb;AACF;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;AACnB","sourcesContent":[".dark-theme-input .form-control {\n  background-color: var(--bs-body-bg) !important;\n  color: #e0e0e0 !important;\n  border: 2px solid var(--bs-border-color) !important;\n}\n\n.dark-theme-input .form-control::placeholder {\n  color: #fff !important;\n}\n\n.dark-theme-input .form-control:focus {\n  border-color: #6200ea !important;\n  box-shadow: 0 0 5px rgba(98, 0, 234, 0.8) !important;\n}\n\n.hold-progress-bar {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  height: 3px;\n  background-color: #ffc107; /* yellow/orange */\n  width: 100%;\n  animation: holdBarFill 3s linear forwards;\n  border-radius: 0 0 4px 4px;\n}\n\n@keyframes holdBarFill {\n  from {\n    width: 0%;\n  }\n  to {\n    width: 100%;\n  }\n}\n\n/* Bulk selection styles */\n.bulk-actions {\n  margin-bottom: 1rem;\n}\n\ninput[type=\"checkbox\"] {\n  cursor: pointer;\n}\n\n.bulk-edit-btn {\n  transition: all 0.3s ease;\n}\n\n.bulk-edit-count {\n  background-color: rgba(255, 255, 255, 0.15);\n  padding: 0.2rem 0.5rem;\n  border-radius: 50%;\n  margin-left: 0.5rem;\n  font-size: 0.8rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
